<head>
    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css"
        integrity="sha512-iecdLmaskl7CVkqkXNQ/ZH/XLlvWZOJyj7Yy7tcenmpD1ypASozpmT/E0iPtmFIB46ZmdtAc9eNBvH0H/ZpiBw=="
        crossorigin="anonymous" referrerpolicy="no-referrer" />
</head>
<app-breadcrumb></app-breadcrumb>

<div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
</div>
<div class="menu-container">
    <div class="row menu-row-container">
        <div class="col-sm-6 gridName-container" style="margin-bottom: 5px;">
            <span class="gridName">DR Mode</span>
        </div>
    </div>
</div>
<div class="table-container">
    <div id="header-container" class="row" style="height: auto;">
        <div class="row">
            <label>DR Mode</label>
            <mat-slide-toggle color="primary" [(ngModel)]="isDrMode" disabled>
                <span class="active-inActive-container" *ngIf="isDrMode==true"
                    [ngStyle]="isDrMode==true?{'color':'green'} : {'color': ''}">Enabled</span>
                <span *ngIf="isDrMode==false"
                    [ngStyle]="isDrMode==false?{'color':'red'} : {'color': ''}">Disabled</span>
            </mat-slide-toggle>
        </div>
        <br>
        <div class="row">
            <div class="button-continer" mat-dialog-actions class="btn-align" style="display: block;">
                <button *ngIf="isDrMode" mat-stroked-button class="addButton" (click)="disableDrFunc()"
                    style="margin-right:1%;">
                    Disable DR Mode
                </button>
                <button *ngIf="!isDrMode" mat-stroked-button class="addButton" (click)="enableDrFunc()"
                    style="margin-right:1%;">
                    Enable DR Mode
                </button>
            </div>
        </div>
    </div>
</div>
<ng-template #drPopup>
    <div class="page-loading-shade" *ngIf="isProcessing">
        <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelDRModeFunction()" mat-button><i
            class="fa popupClose">&#xf00d;</i></button>
    <div mat-dialog-title>
        <label class="popupTitle"> {{ title }}</label>
        <label class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div style="margin: 15px 15px;">
        <div>
            <div class="row">
                <div class="col-md-12">
                    <div><label for="email">Message</label><span *ngIf="!isDrMode" class="mandatory-symbol">*</span>
                    </div>
                    <textarea id="messageOfDrMode" type="text" class="textarea-filed-continers" rows="4" cols="50"
                        [(ngModel)]="comments"></textarea>
                    <span id="messageOfDrMode-required-msg">Please provide the message to {{title}}</span>
                </div>
            </div>
        </div>
    </div>
    <br>
    <div class="button-continer" mat-dialog-actions class="btn-align">
        <button mat-stroked-button class="deleteButton" (click)="enableOrDisableDrModeFunc()">
            {{title}}
        </button>
        <button mat-stroked-button class="cancelButton" (click)="cancelDRModeFunction()">
            <i class="fa fa-close"></i> Cancel
        </button>
    </div>

</ng-template>